const NotasDebitoList = () => import('@/spa/notas-debito/contabilizacao/NotasDebitoList');

export default {
  path: 'notas-debito-contabilizacao',
  name: 'notas-debito-contabilizacao',
  component: NotasDebitoList,
};
